module.exports = __webpack_public_path__ + "media/maps-markers/green-pin-f485e118.svg";